import { useSelector, useDispatch } from 'react-redux';

import { RootState } from '@/store';
import { actions, UtmParams } from '@/store/slices/utm';

export const useUtmParams = () => {
  const dispatch = useDispatch();
  const utmParams = useSelector((state: RootState) => state.utm);

  const setUtmParams = (params: UtmParams) => {
    dispatch(actions.setUtmParams(params));
  };

  const clearUtmParams = () => {
    dispatch(actions.clearUtmParams());
  };

  return {
    utmParams,
    setUtmParams,
    clearUtmParams,
  };
};
